export const ResourceType = {
  YOUTUBE: "youtube",
  WEBSITE: "website",
  FILE: "file"
};
export const safetyTraining = [
  {
    title: "Cryogenic safety",
    link:"https://www.youtube.com/embed/gO-LTUvZ3Pk?si=-5nu2df0GPc0OyHx",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Overview of using compressed gas cylinders. Note that pumping on a regulator is forbidden unless a negative reading is marked on the meter.",
    link:"https://www.youtube.com/embed/YORPnqrH6Ws?si=0U0k1ogyWixLXnQD",
    type: ResourceType.YOUTUBE
  },
  {
    title: 'Soldering safety',
    link:"https://www.youtube.com/embed/3ht_JmfaCNM?si=TNUzPJVKjirqS1jP",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Spot welder safety",
    link:"https://www.youtube.com/embed/lWvfAKx0qiA?si=ToHC-CcVhIiKXfV_",
    type: ResourceType.YOUTUBE
  },
];

export const uhvTechniques = [
  {
    title: "An introduction to UHV",
    link:"https://www.youtube.com/embed/VD69crOFx10?si=dNu5w8bFBy5gFmsO",
    type: ResourceType.YOUTUBE
  },
  {
    title: "A basic introduction to STM",
    link:"https://www.youtube.com/embed/wNEqRq6NyUw?si=qly2vnVWtAdpMPi7",
    type: ResourceType.YOUTUBE
  },
  {
    title: "A basic introduction to XPS",
    link:"https://www.youtube.com/embed/jBd4xy7y4IU?si=FjYJqWsTZB5BSKNZ",
    type: ResourceType.YOUTUBE
  },
  {
    title: "An introduction to AES",
    link:"https://www.youtube.com/embed/Mw7y4DeddCA?si=9ZIzjEXf4WqepNWw",
    type: ResourceType.YOUTUBE
  },  
  {
    title: "A basic introduction to working principles of LEED",
    link:"https://www.youtube.com/embed/ku2YjCO_8cE?si=1P5I9a-Z5HoY3WhS",
    type: ResourceType.YOUTUBE
  },  
  {
    title: "An introduction to working principles of LEEM",
    link:"https://www.youtube.com/embed/A3iEjHiyjAE?si=KkDtyizpRIsPSaHw",
    type: ResourceType.YOUTUBE
  },  
  {
    title: "How to use ARM200F STEM",
    link:"https://www.youtube.com/embed/gn6Ru1hu2ms?si=PCvIUg5vxs-fGuAb",
    type: ResourceType.YOUTUBE
  },
];

export const readingMaterial = [
  {
    title: "High and ultra-high vacuum for science research",
    link:"https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&ved=2ahUKEwjVjcqk0buEAxW3g2oFHdTUB0kQFnoECBoQAQ&url=https%3A%2F%2Fwww.agilent.com%2Fcs%2Flibrary%2Ftraining%2FPublic%2FUHV_Seminar_Handbook.pdf&usg=AOvVaw1zGclBU4Wq0r7zGweus-JK&opi=89978449",
    type: ResourceType.FILE
  },
  {
    title: "BET Theory and how its used to calculate surface area",
    link:"https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&cad=rja&uact=8&ved=2ahUKEwiMysPp0LuEAxVinWoFHRI8AcUQFnoECBcQAQ&url=https%3A%2F%2Fstatic.horiba.com%2Ffileadmin%2FHoriba%2FProducts%2FScientific%2FParticle_Characterization%2FWebinars%2FSlides%2FBET_Theory_Explained.pdf&usg=AOvVaw2h2MNekDZehpQztu9sECX_&opi=89978449",
    type: ResourceType.FILE
  },
];

export const machineShop = [
  {
    title: "Replace Edwards nXDS scroll pump tip seal",
    link:"https://www.youtube.com/embed/vKnh9dxOyhE?si=XcjYofZ8Pq75XRH9",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Replace Agilent IDP-7 scroll pump tip seal",
    link:"https://www.youtube.com/embed/84uyAJ66LCQ?si=6R2X_Bgp8P_laKMo",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Spot welding working principle",
    link:"https://www.youtube.com/embed/AwL1CAg43PU?si=R_TeIMz6ebM2YE9U",
    type: ResourceType.YOUTUBE
  },
  {
    title: "How to solder playlist",
    link:"https://www.youtube.com/embed/videoseries?si=b0htjjrLJWxZ9z_E&amp;list=PLLALQuK1NDriDYU572cmwqCm2bOO_t2Cv",
    type: ResourceType.YOUTUBE
  },
  {
    title: "An introduction to nut and bolt sizes",
    link:"https://www.huyett.com/blog/nuts-and-bolts-sizes",
    type: ResourceType.WEBSITE
  },
  {
    title: "Types of Tube Fittings: Learn the Key Differences",
    link:"https://www.swagelok.com/en/blog/small-bore-tube-fittings-key-differences",
    type: ResourceType.WEBSITE
  },
  {
    title: "Back-Pressure Regulators: How They Work & Tips for Engineers",
    link:"https://www.swagelok.com/en/blog/back-pressure-regulator-set-up-sampling-system-engineers",
    type: ResourceType.WEBSITE
  },
];

export const softwares = [
  {
    title: "Endnote",
    link:"https://libguides.utsa.edu/endnote/install",
    type: ResourceType.WEBSITE
  },
  {
    title: "MountainsSPIP®",
    link:"https://www.digitalsurf.com/software-solutions/scanning-probe-microscopy/",
    type: ResourceType.WEBSITE
  },
  {
    title: "Gwyddion",
    link:"http://gwyddion.net/",
    type: ResourceType.WEBSITE
  },
  {
    title: "Adobe Creative Cloud",
    link:"https://www.utsa.edu/techsolutions/students/software/",
    type: ResourceType.WEBSITE
  },
  {
    title: "Gimp",
    link:"https://www.gimp.org/",
    type: ResourceType.WEBSITE
  },
  {
    title: "ImageJ",
    link:"https://imagej.net/ij/index.html",
    type: ResourceType.WEBSITE
  },
  {
    title: "Blender",
    link:"https://www.blender.org/",
    type: ResourceType.WEBSITE
  },
  {
    title: "CasaXPS",
    link:"http://www.casaxps.com/casaxps-training/bgn_course/bg_index.htm",
    type: ResourceType.WEBSITE
  },
  {
    title: "Getting Started with Mountains® playlist",
    link:"https://www.youtube.com/embed/videoseries?si=rjDwO6CZFdIiYRGJ&amp;list=PLK5Jlf_LO8riZWIgynw1Q9Ll91BvSkbEH",
    type: ResourceType.YOUTUBE
  },
  {
    title: "MountainsSPIP 8 SPM images analysis playlist",
    link:"https://www.youtube.com/embed/videoseries?si=-CqMuoBOrg1l4ANb&amp;list=PLK5Jlf_LO8rj_LoP3QPtZ3Zs1er8MmwoF",
    type: ResourceType.YOUTUBE
  },
  {
    title: "CasaXPS Introduction Videos",
    link:"https://www.youtube.com/embed/videoseries?si=Sav1I2eQR3R3gVQf&amp;list=PLljMzbEbFCAAdmgZQ7eGK3_ojLiHQdWn9",
    type: ResourceType.YOUTUBE
  },
  {
    title: "CasaXPS Understanding Quantification by XPS",
    link:"https://www.youtube.com/embed/videoseries?si=k_ZsDvZsWhlNr3zX&amp;list=PLljMzbEbFCABExP2KyyDr-UCf7rI_cbjm",
    type: ResourceType.YOUTUBE
  },
  {
    title: "CasaXPS Quantification of XPS Spectra",
    link:"https://www.youtube.com/embed/videoseries?si=d98mXwIJkBdlpw3N&amp;list=PLljMzbEbFCABY3P83A32wzrmNU_9Cl7oC",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Gwyddion Tutorials (outdated but insightful)",
    link:"https://www.youtube.com/embed/videoseries?si=eVm88l5ccnWS1JmE&amp;list=PL8wbo3f6nAZQJh-74nxRk4uhzugXxC2wY",
    type: ResourceType.YOUTUBE
  },
  {
    title: "Blender tutorial",
    link:"https://www.youtube.com/embed/videoseries?si=s-0Zel3pIgSuyk1a&amp;list=PLjEaoINr3zgEPv5y--4MKpciLaoQYZB1Z",
    type: ResourceType.YOUTUBE
  },
]